import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import portalService from '../../services/portalService';
import PortalShell from './PortalShell';
import PortalLocationPicker, { detectMyLocation } from './PortalLocationPicker';
import GiveTakeBoard from '../../components/GiveTakeBoard';

/**
 * /portal/give-take — the standalone Give/Take board. Shows offerings and asks
 * from members worldwide by default, with an optional local-only radius filter,
 * in the gold Portal Noir register.
 */
export default function PortalGiveTakePage() {
  const navigate = useNavigate();
  const [myLocation, setMyLocation] = useState(null);
  const [ready, setReady] = useState(false);

  // Server is authoritative on membership — bounce non-members to /portal.
  useEffect(() => {
    let cancelled = false;
    portalService.getState().then((r) => {
      if (cancelled) return;
      if (r.success && r.data?.state !== 'accepted') navigate('/noir', { replace: true });
      else if (r.success) setReady(true);
    });
    return () => { cancelled = true; };
  }, [navigate]);

  const saveLocation = async ({ lat, lng, label }) => {
    const r = await portalService.setMyLocation({ latitude: lat, longitude: lng, label });
    if (r.success) setMyLocation(r.data);
  };

  useEffect(() => {
    portalService.getMyLocation().then(async (r) => {
      if (!r.success) return;
      setMyLocation(r.data || null);
      if (!r.data?.label) {
        const detected = await detectMyLocation();
        if (detected) await saveLocation(detected);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PortalShell viewerState="accepted">
      <div className="wrap" style={{ paddingTop: 'clamp(40px,7vw,80px)', paddingBottom: 100 }}>
        <section className="hero enter" style={{ marginBottom: 40 }}>
          <span className="kicker">GIVE / TAKE</span>
          <h1 className="display" style={{ fontSize: 'clamp(42px,7vw,96px)', marginTop: 18 }}>Take care of each other<span className="dot">.</span></h1>
          <p className="lede" style={{ marginTop: 24, maxWidth: '46ch' }}>A board of generous offerings and thoughtful asks, from members around the world.</p>
          <p className="gtsubhead" style={{ margin: '14px 0 0' }}>Posts clear after 24 hours, or the moment they’re claimed.</p>
        </section>

        <div className="enter enter-2" style={{ marginBottom: 22 }}>
          <PortalLocationPicker
            current={myLocation?.label ? { label: myLocation.label, lat: myLocation.latitude, lng: myLocation.longitude } : null}
            onChange={saveLocation}
            radiusMiles={myLocation?.radiusMiles || 50}
          />
        </div>

        <div className="enter enter-2">
          {ready && <GiveTakeBoard context="portal" variant="portal" />}
        </div>
      </div>
    </PortalShell>
  );
}
